import TitledScoreChart from './TitledScoreChart'

export default TitledScoreChart
